import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchFilter'
})
export class SearchFilterPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (args === undefined) {
      return value;
    }
    if (value !== null && args !== undefined) {
      if (args === '') {
        return value;
      } else if (typeof value[0] === 'object') {
        let term = args.charAt(0).toUpperCase() + args.slice(1);
        return value.filter(item => item.name.startsWith(term));
      } else if (typeof value[0] === 'string') {
        let term = args.charAt(0).toUpperCase() + args.slice(1);
        return value.filter(item => item.startsWith(term));
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common/pipes/search-filter.pipe.ts